<template>
    <Button
        :label="$t('pages.product_detail_page.share.label')"
        :leading-icon="Share"
        class="border border-gray-300 bg-white text-black/60 hover:border-primary hover:text-primary"
        only-icon
        pill
        no-tooltip
        @click="sharePage"
    />
</template>

<script setup lang="ts">
import Button from '@/components/buttons/Button.vue';
import { pushShare } from '@/composables/useDataLayer';
import { writeToClipboard } from '@/lib/clipboard';
import { useProductStore } from '@/stores/products/ProductStore';
import { Share } from '@lucide/vue';
import { useI18n } from 'vue-i18n';
import { toast } from 'vue-sonner';

const { t } = useI18n();
const productStore = useProductStore();

// Opens the phone's share sheet; without one (or on http) it copies the link instead.
async function sharePage(): Promise<void> {
    const url = window.location.href;
    const itemId = productStore.configurableProduct.group_identifier;

    if (!('share' in navigator)) {
        await writeToClipboard(url);
        pushShare('copy_link', 'product', itemId);
        toast.success(t('pages.product_detail_page.share.copied'));

        return;
    }

    navigator
        .share({ title: document.title, url })
        .then((): void => pushShare('native_share', 'product', itemId))
        .catch(() => undefined);
}
</script>
